import BetsShard from './bets-shard';
export default BetsShard;
